
    import Vue from "vue";
    import LogType from "@/models/api/logType/LogType";
    import VuetifyFormMethods from "@/models/vuetify-form-methods";
    import { AxiosError } from "axios";
    import { SnackbarService } from '../../services/SnackbarService';
    import { LogTypeService } from '../../services/LogTypeService';
    import { DataTableHelper } from '@/helpers/DataTableHelper';
    import SelectListItem from '../../models/SelectListItem';
    import { LogTypes } from '../../models/Enums';
    import { LogService } from '../../services/LogService';
    import LogTypesPage from './LogTypes.vue';

    export default Vue.extend({
        components: {
            LogTypesPage
        },
        data() {
            return {
                pageHeader: this.$vuetify.lang.t('$vuetify.menu_logs'),

                // Table
                expanded: [],
                singleExpand: false,
                totalCount: 0,
                items: [],
                loading: true,
                options: {},
                tableHeaders: [
                    {
                        text: "logType.logType", value: "logType", sortable: false
                    },
                    {
                        text: "message", value: "message", sortable: false
                    },
                    {
                        text: "created", value: "createdText", sortable: false
                    },
                    {
                        text: "createdBy", value: "createdBy", sortable: false
                    },
                ],

                logTypes: [] as SelectListItem[],
                selectedLogType: null as number | null,
                from: (new Date()).toLocaleDateString('sv-SE'),
                to: (new Date()).toLocaleDateString('sv-SE'),

            };
        },
        created() {
            DataTableHelper.adaptTableHeaders(this.tableHeaders, this);

            this.logTypes = [];
            Object.values(LogTypes).map((n: string | LogTypes) => {
                if (typeof LogTypes[n as any] === 'number') {
                    this.logTypes.push(new SelectListItem(this.getLogTypeName(LogTypes[n as any]), LogTypes[n as any]));
                }
            });
        },
        watch: {
            options: {
                handler() {
                    this.getPaged();
                },
                deep: true,
            },
            selectedLogType: {
                handler() {
                    this.getPaged();
                },
            },
            from: {
                handler() {
                    this.getPaged();
                },
            },
            to: {
                handler() {
                    this.getPaged();
                },
            },
        },
        methods: {
            getLogTypeName(logType: any): string {
                return this.$vuetify.lang.t('$vuetify.logType.' + LogTypes[logType as LogTypes]) as string;
            },
            async getPaged() {
                this.loading = true;

                const sortBy = (this.options as any).sortBy ?? [];
                const sortDesc = (this.options as any).sortDesc ?? [];
                const page = (this.options as any).page ?? 1;
                const itemsPerPage = (this.options as any).itemsPerPage ?? 10;

                const data = { sortBy: sortBy, sortDesc: sortDesc, page: page, itemsPerPage: itemsPerPage, logType: this.selectedLogType, from: this.from, to: this.to };

                LogService.GetLogsPaged(data).then((response: any) => {
                    this.totalCount = response.data.totalCount;
                    this.items = response.data.items;
                }).catch((error) => {
                    console.error(error);
                }).finally(() => {
                    this.loading = false;
                });
            },
        },
    })


